import { useState } from "react";
import { Link } from "react-router-dom";
import { CloudLightning, CloudSnow, X } from "lucide-react";
import { useWeather } from "@/lib/weather";

const SEEN = "readoo_meteo_alert_closed";

// Avviso maltempo (temporali o neve entro 24 ore) per la città del lettore; chiuso, non ricompare per lo stesso evento.
export function WeatherAlert() {
  const { city, data } = useWeather();
  const [closed, setClosed] = useState(() => localStorage.getItem(SEEN) || "");
  const alert = data?.alert;
  if (!city || !alert || closed === alert.id) return null;
  const Icon = alert.kind === "neve" ? CloudSnow : CloudLightning;
  const close = () => { localStorage.setItem(SEEN, alert.id); setClosed(alert.id); };
  return (
    <div data-testid="weather-alert" role="status" className="flex items-center gap-3 rounded-xl border border-[#f59e0b]/50 bg-[#f59e0b]/10 px-4 py-3">
      <Icon size={18} className="text-[#f59e0b] shrink-0" />
      <p data-testid="weather-alert-text" className="flex-1 text-sm text-onSurface">
        <span className="font-semibold">{alert.kind === "neve" ? "Neve" : "Temporali"} in arrivo a {city.name}</span>
        {" "}· {alert.day} dalle {alert.time}.{" "}
        <Link to="/meteo" data-testid="weather-alert-link" className="font-semibold text-brand hover:underline">Vedi il meteo</Link>
      </p>
      <button type="button" data-testid="weather-alert-close" onClick={close} aria-label="Chiudi avviso" className="p-1 text-subtle hover:text-onSurface">
        <X size={16} />
      </button>
    </div>
  );
}
